// extracted by mini-css-extract-plugin
module.exports = {"invalidItem":"_6Ur69"};